import { a4 as sanitize_props, a6 as rest_props, Y as attributes, a3 as clsx, X as ensure_array_like, a7 as element, a5 as slot, V as bind_props, a1 as spread_props, W as attr } from "./index.js";
import { c as cn, B as Button } from "./button.js";
import { tv } from "tailwind-variants";
import { f as fallback, e as escape_html } from "./context.js";
const defaultAttributes$1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function Icon$1($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const $$restProps = rest_props($$sanitized_props, [
    "name",
    "color",
    "size",
    "strokeWidth",
    "absoluteStrokeWidth",
    "iconNode"
  ]);
  $$renderer.component(($$renderer2) => {
    let name = fallback($$props["name"], void 0);
    let color = fallback($$props["color"], "currentColor");
    let size = fallback($$props["size"], 24);
    let strokeWidth = fallback($$props["strokeWidth"], 2);
    let absoluteStrokeWidth = fallback($$props["absoluteStrokeWidth"], false);
    let iconNode = fallback($$props["iconNode"], () => [], true);
    const mergeClasses = (...classes) => classes.filter((className, index, array) => {
      return Boolean(className) && array.indexOf(className) === index;
    }).join(" ");
    $$renderer2.push(`<svg${attributes(
      {
        ...defaultAttributes$1,
        ...$$restProps,
        width: size,
        height: size,
        stroke: color,
        "stroke-width": absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        class: clsx(mergeClasses("lucide-icon", "lucide", name ? `lucide-${name}` : "", $$sanitized_props.class))
      },
      void 0,
      void 0,
      void 0,
      3
    )}><!--[-->`);
    const each_array = ensure_array_like(iconNode);
    for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
      let [tag, attrs] = each_array[$$index];
      element($$renderer2, tag, () => {
        $$renderer2.push(`${attributes({ ...attrs }, void 0, void 0, void 0, 3)}`);
      });
    }
    $$renderer2.push(`<!--]--><!--[-->`);
    slot($$renderer2, $$props, "default", {});
    $$renderer2.push(`<!--]--></svg>`);
    bind_props($$props, {
      name,
      color,
      size,
      strokeWidth,
      absoluteStrokeWidth,
      iconNode
    });
  });
}
function Award($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    [
      "path",
      {
        "d": "m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"
      }
    ],
    ["circle", { "cx": "12", "cy": "8", "r": "6" }]
  ];
  Icon$1($$renderer, spread_props([
    { name: "award" },
    $$sanitized_props,
    {
      /**
       * @component @name Award
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTUuNDc3IDEyLjg5IDEuNTE1IDguNTI2YS41LjUgMCAwIDEtLjgxLjQ3bC0zLjU4LTIuNjg3YTEgMSAwIDAgMC0xLjE5NyAwbC0zLjU4NiAyLjY4NmEuNS41IDAgMCAxLS44MS0uNDY5bDEuNTE0LTguNTI2IiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iOCIgcj0iNiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/award
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Book_open($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    ["path", { "d": "M12 7v14" }],
    [
      "path",
      {
        "d": "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"
      }
    ]
  ];
  Icon$1($$renderer, spread_props([
    { name: "book-open" },
    $$sanitized_props,
    {
      /**
       * @component @name BookOpen
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgN3YxNCIgLz4KICA8cGF0aCBkPSJNMyAxOGExIDEgMCAwIDEtMS0xVjRhMSAxIDAgMCAxIDEtMWg1YTQgNCAwIDAgMSA0IDQgNCA0IDAgMCAxIDQtNGg1YTEgMSAwIDAgMSAxIDF2MTNhMSAxIDAgMCAxLTEgMWgtNmEzIDMgMCAwIDAtMyAzIDMgMyAwIDAgMC0zLTN6IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/book-open
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Calendar($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    ["path", { "d": "M8 2v4" }],
    ["path", { "d": "M16 2v4" }],
    [
      "rect",
      { "width": "18", "height": "18", "x": "3", "y": "4", "rx": "2" }
    ],
    ["path", { "d": "M3 10h18" }]
  ];
  Icon$1($$renderer, spread_props([
    { name: "calendar" },
    $$sanitized_props,
    {
      /**
       * @component @name Calendar
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOCAydjQiIC8+CiAgPHBhdGggZD0iTTE2IDJ2NCIgLz4KICA8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHg9IjMiIHk9IjQiIHJ4PSIyIiAvPgogIDxwYXRoIGQ9Ik0zIDEwaDE4IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/calendar
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Circle_alert($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    ["circle", { "cx": "12", "cy": "12", "r": "10" }],
    ["line", { "x1": "12", "x2": "12", "y1": "8", "y2": "12" }],
    [
      "line",
      { "x1": "12", "x2": "12.01", "y1": "16", "y2": "16" }
    ]
  ];
  Icon$1($$renderer, spread_props([
    { name: "circle-alert" },
    $$sanitized_props,
    {
      /**
       * @component @name CircleAlert
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgLz4KICA8bGluZSB4MT0iMTIiIHgyPSIxMiIgeTE9IjgiIHkyPSIxMiIgLz4KICA8bGluZSB4MT0iMTIiIHgyPSIxMi4wMSIgeTE9IjE2IiB5Mj0iMTYiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/circle-alert
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Circle_check_big($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    ["path", { "d": "M21.801 10A10 10 0 1 1 17 3.335" }],
    ["path", { "d": "m9 11 3 3L22 4" }]
  ];
  Icon$1($$renderer, spread_props([
    { name: "circle-check-big" },
    $$sanitized_props,
    {
      /**
       * @component @name CircleCheckBig
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjEuODAxIDEwQTEwIDEwIDAgMSAxIDE3IDMuMzM1IiAvPgogIDxwYXRoIGQ9Im05IDExIDMgM0wyMiA0IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/circle-check-big
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Circle_question_mark($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    ["circle", { "cx": "12", "cy": "12", "r": "10" }],
    ["path", { "d": "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }],
    ["path", { "d": "M12 17h.01" }]
  ];
  Icon$1($$renderer, spread_props([
    { name: "circle-question-mark" },
    $$sanitized_props,
    {
      /**
       * @component @name CircleQuestionMark
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgLz4KICA8cGF0aCBkPSJNOS4wOSA5YTMgMyAwIDAgMSA1LjgzIDFjMCAyLTMgMy0zIDMiIC8+CiAgPHBhdGggZD0iTTEyIDE3aC4wMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/circle-question-mark
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Clock($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    ["path", { "d": "M12 6v6l4 2" }],
    ["circle", { "cx": "12", "cy": "12", "r": "10" }]
  ];
  Icon$1($$renderer, spread_props([
    { name: "clock" },
    $$sanitized_props,
    {
      /**
       * @component @name Clock
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgNnY2bDQgMiIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/clock
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Code($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    ["path", { "d": "m16 18 6-6-6-6" }],
    ["path", { "d": "m8 6-6 6 6 6" }]
  ];
  Icon$1($$renderer, spread_props([
    { name: "code" },
    $$sanitized_props,
    {
      /**
       * @component @name Code
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTYgMTggNi02LTYtNiIgLz4KICA8cGF0aCBkPSJtOCA2LTYgNiA2IDYiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/code
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function File_text($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    [
      "path",
      {
        "d": "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"
      }
    ],
    ["path", { "d": "M14 2v5a1 1 0 0 0 1 1h5" }],
    ["path", { "d": "M10 9H8" }],
    ["path", { "d": "M16 13H8" }],
    ["path", { "d": "M16 17H8" }]
  ];
  Icon$1($$renderer, spread_props([
    { name: "file-text" },
    $$sanitized_props,
    {
      /**
       * @component @name FileText
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiAyMmEyIDIgMCAwIDEtMi0yVjRhMiAyIDAgMCAxIDItMmg4YTIuNCAyLjQgMCAwIDEgMS43MDQuNzA2bDMuNTg4IDMuNTg4QTIuNCAyLjQgMCAwIDEgMjAgOHYxMmEyIDIgMCAwIDEtMiAyeiIgLz4KICA8cGF0aCBkPSJNMTQgMnY1YTEgMSAwIDAgMCAxIDFoNSIgLz4KICA8cGF0aCBkPSJNMTAgOUg4IiAvPgogIDxwYXRoIGQ9Ik0xNiAxM0g4IiAvPgogIDxwYXRoIGQ9Ik0xNiAxN0g4IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/file-text
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function List($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    ["path", { "d": "M3 5h.01" }],
    ["path", { "d": "M3 12h.01" }],
    ["path", { "d": "M3 19h.01" }],
    ["path", { "d": "M8 5h13" }],
    ["path", { "d": "M8 12h13" }],
    ["path", { "d": "M8 19h13" }]
  ];
  Icon$1($$renderer, spread_props([
    { name: "list" },
    $$sanitized_props,
    {
      /**
       * @component @name List
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMyA1aC4wMSIgLz4KICA8cGF0aCBkPSJNMyAxMmguMDEiIC8+CiAgPHBhdGggZD0iTTMgMTloLjAxIiAvPgogIDxwYXRoIGQ9Ik04IDVoMTMiIC8+CiAgPHBhdGggZD0iTTggMTJoMTMiIC8+CiAgPHBhdGggZD0iTTggMTloMTMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/list
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Message_circle($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    [
      "path",
      {
        "d": "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"
      }
    ]
  ];
  Icon$1($$renderer, spread_props([
    { name: "message-circle" },
    $$sanitized_props,
    {
      /**
       * @component @name MessageCircle
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMi45OTIgMTYuMzQyYTIgMiAwIDAgMSAuMDk0IDEuMTY3bC0xLjA2NSAzLjI5YTEgMSAwIDAgMCAxLjIzNiAxLjE2OGwzLjQxMy0uOTk4YTIgMiAwIDAgMSAxLjA5OS4wOTIgMTAgMTAgMCAxIDAtNC43NzctNC43MTkiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/message-circle
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Play($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    [
      "path",
      {
        "d": "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z"
      }
    ]
  ];
  Icon$1($$renderer, spread_props([
    { name: "play" },
    $$sanitized_props,
    {
      /**
       * @component @name Play
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNSA1YTIgMiAwIDAgMSAzLjAwOC0xLjcyOGwxMS45OTcgNi45OThhMiAyIDAgMCAxIC4wMDMgMy40NThsLTEyIDdBMiAyIDAgMCAxIDUgMTl6IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/play
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Share_2($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    ["circle", { "cx": "18", "cy": "5", "r": "3" }],
    ["circle", { "cx": "6", "cy": "12", "r": "3" }],
    ["circle", { "cx": "18", "cy": "19", "r": "3" }],
    [
      "line",
      { "x1": "8.59", "x2": "15.42", "y1": "13.51", "y2": "17.49" }
    ],
    [
      "line",
      { "x1": "15.41", "x2": "8.59", "y1": "6.51", "y2": "10.49" }
    ]
  ];
  Icon$1($$renderer, spread_props([
    { name: "share-2" },
    $$sanitized_props,
    {
      /**
       * @component @name Share2
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxOCIgY3k9IjUiIHI9IjMiIC8+CiAgPGNpcmNsZSBjeD0iNiIgY3k9IjEyIiByPSIzIiAvPgogIDxjaXJjbGUgY3g9IjE4IiBjeT0iMTkiIHI9IjMiIC8+CiAgPGxpbmUgeDE9IjguNTkiIHgyPSIxNS40MiIgeTE9IjEzLjUxIiB5Mj0iMTcuNDkiIC8+CiAgPGxpbmUgeDE9IjE1LjQxIiB4Mj0iOC41OSIgeTE9IjYuNTEiIHkyPSIxMC40OSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/share-2
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Star($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    [
      "path",
      {
        "d": "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
      }
    ]
  ];
  Icon$1($$renderer, spread_props([
    { name: "star" },
    $$sanitized_props,
    {
      /**
       * @component @name Star
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEuNTI1IDIuMjk1YS41My41MyAwIDAgMSAuOTUgMGwyLjMxIDQuNjc5YTIuMTIzIDIuMTIzIDAgMCAwIDEuNTk1IDEuMTZsNS4xNjYuNzU2YS41My41MyAwIDAgMSAuMjk0LjkwNGwtMy43MzYgMy42MzhhMi4xMjMgMi4xMjMgMCAwIDAtLjYxMSAxLjg3OGwuODgyIDUuMTRhLjUzLjUzIDAgMCAxLS43NzEuNTZsLTQuNjE4LTIuNDI4YTIuMTIyIDIuMTIyIDAgMCAwLTEuOTczIDBMNi4zOTYgMjEuMDFhLjUzLjUzIDAgMCAxLS43Ny0uNTZsLjg4MS01LjEzOWEyLjEyMiAyLjEyMiAwIDAgMC0uNjExLTEuODc5TDIuMTYgOS43OTVhLjUzLjUzIDAgMCAxIC4yOTQtLjkwNmw1LjE2NS0uNzU1YTIuMTIyIDIuMTIyIDAgMCAwIDEuNTk3LTEuMTZ6IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/star
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Target($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    ["circle", { "cx": "12", "cy": "12", "r": "10" }],
    ["circle", { "cx": "12", "cy": "12", "r": "6" }],
    ["circle", { "cx": "12", "cy": "12", "r": "2" }]
  ];
  Icon$1($$renderer, spread_props([
    { name: "target" },
    $$sanitized_props,
    {
      /**
       * @component @name Target
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSI2IiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/target
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Trending_up($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    ["path", { "d": "M16 7h6v6" }],
    ["path", { "d": "m22 7-8.5 8.5-5-5L2 17" }]
  ];
  Icon$1($$renderer, spread_props([
    { name: "trending-up" },
    $$sanitized_props,
    {
      /**
       * @component @name TrendingUp
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgN2g2djYiIC8+CiAgPHBhdGggZD0ibTIyIDctOC41IDguNS01LTVMMiAxNyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/trending-up
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function User_check($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    ["path", { "d": "m16 11 2 2 4-4" }],
    ["path", { "d": "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }],
    ["circle", { "cx": "9", "cy": "7", "r": "4" }]
  ];
  Icon$1($$renderer, spread_props([
    { name: "user-check" },
    $$sanitized_props,
    {
      /**
       * @component @name UserCheck
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTYgMTEgMiAyIDQtNCIgLz4KICA8cGF0aCBkPSJNMTYgMjF2LTJhNCA0IDAgMCAwLTQtNEg2YTQgNCAwIDAgMC00IDR2MiIgLz4KICA8Y2lyY2xlIGN4PSI5IiBjeT0iNyIgcj0iNCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/user-check
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function User($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    ["path", { "d": "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" }],
    ["circle", { "cx": "12", "cy": "7", "r": "4" }]
  ];
  Icon$1($$renderer, spread_props([
    { name: "user" },
    $$sanitized_props,
    {
      /**
       * @component @name User
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTkgMjF2LTJhNCA0IDAgMCAwLTQtNEg5YTQgNCAwIDAgMC00IDR2MiIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjciIHI9IjQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/user
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Users($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    ["path", { "d": "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }],
    ["path", { "d": "M16 3.128a4 4 0 0 1 0 7.744" }],
    ["path", { "d": "M22 21v-2a4 4 0 0 0-3-3.87" }],
    ["circle", { "cx": "9", "cy": "7", "r": "4" }]
  ];
  Icon$1($$renderer, spread_props([
    { name: "users" },
    $$sanitized_props,
    {
      /**
       * @component @name Users
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgMjF2LTJhNCA0IDAgMCAwLTQtNEg2YTQgNCAwIDAgMC00IDR2MiIgLz4KICA8cGF0aCBkPSJNMTYgMy4xMjhhNCA0IDAgMCAxIDAgNy43NDQiIC8+CiAgPHBhdGggZD0iTTIyIDIxdi0yYTQgNCAwIDAgMC0zLTMuODciIC8+CiAgPGNpcmNsZSBjeD0iOSIgY3k9IjciIHI9IjQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/users
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Video($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    [
      "path",
      {
        "d": "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"
      }
    ],
    [
      "rect",
      { "x": "2", "y": "6", "width": "14", "height": "12", "rx": "2" }
    ]
  ];
  Icon$1($$renderer, spread_props([
    { name: "video" },
    $$sanitized_props,
    {
      /**
       * @component @name Video
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTYgMTMgNS4yMjMgMy40ODJhLjUuNSAwIDAgMCAuNzc3LS40MTZWNy44N2EuNS41IDAgMCAwLS43NTItLjQzMkwxNiAxMC41IiAvPgogIDxyZWN0IHg9IjIiIHk9IjYiIHdpZHRoPSIxNCIgaGVpZ2h0PSIxMiIgcng9IjIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/video
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function X($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  const iconNode = [
    ["path", { "d": "M18 6 6 18" }],
    ["path", { "d": "m6 6 12 12" }]
  ];
  Icon$1($$renderer, spread_props([
    { name: "x" },
    $$sanitized_props,
    {
      /**
       * @component @name X
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTggNiA2IDE4IiAvPgogIDxwYXRoIGQ9Im02IDYgMTIgMTIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/x
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$renderer2) => {
        $$renderer2.push(`<!--[-->`);
        slot($$renderer2, $$props, "default", {});
        $$renderer2.push(`<!--]-->`);
      },
      $$slots: { default: true }
    }
  ]));
}
const defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function Icon($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    const {
      name,
      color = "currentColor",
      size = 24,
      strokeWidth = 2,
      absoluteStrokeWidth = false,
      iconNode = [],
      children,
      $$slots,
      $$events,
      ...props
    } = $$props;
    $$renderer2.push(`<svg${attributes(
      {
        ...defaultAttributes,
        ...props,
        width: size,
        height: size,
        stroke: color,
        "stroke-width": absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        class: clsx(["lucide-icon lucide", name && `lucide-${name}`, props.class])
      },
      void 0,
      void 0,
      void 0,
      3
    )}><!--[-->`);
    const each_array = ensure_array_like(iconNode);
    for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
      let [tag, attrs] = each_array[$$index];
      element($$renderer2, tag, () => {
        $$renderer2.push(`${attributes({ ...attrs }, void 0, void 0, void 0, 3)}`);
      });
    }
    $$renderer2.push(`<!--]-->`);
    children?.($$renderer2);
    $$renderer2.push(`<!----></svg>`);
  });
}
function Brain($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { $$slots, $$events, ...props } = $$props;
    const iconNode = [
      ["path", { "d": "M12 18V5" }],
      [
        "path",
        { "d": "M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4" }
      ],
      [
        "path",
        { "d": "M17.598 6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5" }
      ],
      ["path", { "d": "M17.997 5.125a4 4 0 0 1 2.526 5.77" }],
      ["path", { "d": "M18 18a4 4 0 0 0 2-7.464" }],
      [
        "path",
        { "d": "M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517" }
      ],
      ["path", { "d": "M6 18a4 4 0 0 1-2-7.464" }],
      ["path", { "d": "M6.003 5.125a4 4 0 0 0-2.526 5.77" }]
    ];
    Icon($$renderer2, spread_props([
      { name: "brain" },
      /**
       * @component @name Brain
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMThWNSIgLz4KICA8cGF0aCBkPSJNMTUgMTNhNC4xNyA0LjE3IDAgMCAxLTMtNCA0LjE3IDQuMTcgMCAwIDEtMyA0IiAvPgogIDxwYXRoIGQ9Ik0xNy41OTggNi41QTMgMyAwIDEgMCAxMiA1YTMgMyAwIDEgMC01LjU5OCAxLjUiIC8+CiAgPHBhdGggZD0iTTE3Ljk5NyA1LjEyNWE0IDQgMCAwIDEgMi41MjYgNS43NyIgLz4KICA8cGF0aCBkPSJNMTggMThhNCA0IDAgMCAwIDItNy40NjQiIC8+CiAgPHBhdGggZD0iTTE5Ljk2NyAxNy40ODNBNCA0IDAgMSAxIDEyIDE4YTQgNCAwIDEgMS03Ljk2Ny0uNTE3IiAvPgogIDxwYXRoIGQ9Ik02IDE4YTQgNCAwIDAgMS0yLTcuNDY0IiAvPgogIDxwYXRoIGQ9Ik02LjAwMyA1LjEyNWE0IDQgMCAwIDAtMi41MjYgNS43NyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/brain
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      props,
      {
        iconNode,
        children: ($$renderer3) => {
          props.children?.($$renderer3);
          $$renderer3.push(`<!---->`);
        },
        $$slots: { default: true }
      }
    ]));
  });
}
function Calculator($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { $$slots, $$events, ...props } = $$props;
    const iconNode = [
      [
        "rect",
        { "width": "16", "height": "20", "x": "4", "y": "2", "rx": "2" }
      ],
      ["line", { "x1": "8", "x2": "16", "y1": "6", "y2": "6" }],
      ["line", { "x1": "16", "x2": "16", "y1": "14", "y2": "18" }],
      ["path", { "d": "M16 10h.01" }],
      ["path", { "d": "M12 10h.01" }],
      ["path", { "d": "M8 10h.01" }],
      ["path", { "d": "M12 14h.01" }],
      ["path", { "d": "M8 14h.01" }],
      ["path", { "d": "M12 18h.01" }],
      ["path", { "d": "M8 18h.01" }]
    ];
    Icon($$renderer2, spread_props([
      { name: "calculator" },
      /**
       * @component @name Calculator
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMjAiIHg9IjQiIHk9IjIiIHJ4PSIyIiAvPgogIDxsaW5lIHgxPSI4IiB4Mj0iMTYiIHkxPSI2IiB5Mj0iNiIgLz4KICA8bGluZSB4MT0iMTYiIHgyPSIxNiIgeTE9IjE0IiB5Mj0iMTgiIC8+CiAgPHBhdGggZD0iTTE2IDEwaC4wMSIgLz4KICA8cGF0aCBkPSJNMTIgMTBoLjAxIiAvPgogIDxwYXRoIGQ9Ik04IDEwaC4wMSIgLz4KICA8cGF0aCBkPSJNMTIgMTRoLjAxIiAvPgogIDxwYXRoIGQ9Ik04IDE0aC4wMSIgLz4KICA8cGF0aCBkPSJNMTIgMThoLjAxIiAvPgogIDxwYXRoIGQ9Ik04IDE4aC4wMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/calculator
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      props,
      {
        iconNode,
        children: ($$renderer3) => {
          props.children?.($$renderer3);
          $$renderer3.push(`<!---->`);
        },
        $$slots: { default: true }
      }
    ]));
  });
}
function File_check($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { $$slots, $$events, ...props } = $$props;
    const iconNode = [
      [
        "path",
        {
          "d": "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"
        }
      ],
      ["path", { "d": "M14 2v5a1 1 0 0 0 1 1h5" }],
      ["path", { "d": "m9 15 2 2 4-4" }]
    ];
    Icon($$renderer2, spread_props([
      { name: "file-check" },
      /**
       * @component @name FileCheck
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiAyMmEyIDIgMCAwIDEtMi0yVjRhMiAyIDAgMCAxIDItMmg4YTIuNCAyLjQgMCAwIDEgMS43MDQuNzA2bDMuNTg4IDMuNTg4QTIuNCAyLjQgMCAwIDEgMjAgOHYxMmEyIDIgMCAwIDEtMiAyeiIgLz4KICA8cGF0aCBkPSJNMTQgMnY1YTEgMSAwIDAgMCAxIDFoNSIgLz4KICA8cGF0aCBkPSJtOSAxNSAyIDIgNC00IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/file-check
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      props,
      {
        iconNode,
        children: ($$renderer3) => {
          props.children?.($$renderer3);
          $$renderer3.push(`<!---->`);
        },
        $$slots: { default: true }
      }
    ]));
  });
}
function Footprints($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { $$slots, $$events, ...props } = $$props;
    const iconNode = [
      [
        "path",
        {
          "d": "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z"
        }
      ],
      [
        "path",
        {
          "d": "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z"
        }
      ],
      ["path", { "d": "M16 17h4" }],
      ["path", { "d": "M4 13h4" }]
    ];
    Icon($$renderer2, spread_props([
      { name: "footprints" },
      /**
       * @component @name Footprints
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNCAxNnYtMi4zOEM0IDExLjUgMi45NyAxMC41IDMgOGMuMDMtMi43MiAxLjQ5LTYgNC41LTZDOS4zNyAyIDEwIDMuOCAxMCA1LjVjMCAzLjExLTIgNS42Ni0yIDguNjhWMTZhMiAyIDAgMSAxLTQgMFoiIC8+CiAgPHBhdGggZD0iTTIwIDIwdi0yLjM4YzAtMi4xMiAxLjAzLTMuMTIgMS01LjYyLS4wMy0yLjcyLTEuNDktNi00LjUtNkMxNC42MyA2IDE0IDcuOCAxNCA5LjVjMCAzLjExIDIgNS42NiAyIDguNjhWMjBhMiAyIDAgMSAwIDQgMFoiIC8+CiAgPHBhdGggZD0iTTE2IDE3aDQiIC8+CiAgPHBhdGggZD0iTTQgMTNoNCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/footprints
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      props,
      {
        iconNode,
        children: ($$renderer3) => {
          props.children?.($$renderer3);
          $$renderer3.push(`<!---->`);
        },
        $$slots: { default: true }
      }
    ]));
  });
}
function Languages($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { $$slots, $$events, ...props } = $$props;
    const iconNode = [
      ["path", { "d": "m5 8 6 6" }],
      ["path", { "d": "m4 14 6-6 2-3" }],
      ["path", { "d": "M2 5h12" }],
      ["path", { "d": "M7 2h1" }],
      ["path", { "d": "m22 22-5-10-5 10" }],
      ["path", { "d": "M14 18h6" }]
    ];
    Icon($$renderer2, spread_props([
      { name: "languages" },
      /**
       * @component @name Languages
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtNSA4IDYgNiIgLz4KICA8cGF0aCBkPSJtNCAxNCA2LTYgMi0zIiAvPgogIDxwYXRoIGQ9Ik0yIDVoMTIiIC8+CiAgPHBhdGggZD0iTTcgMmgxIiAvPgogIDxwYXRoIGQ9Im0yMiAyMi01LTEwLTUgMTAiIC8+CiAgPHBhdGggZD0iTTE0IDE4aDYiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/languages
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      props,
      {
        iconNode,
        children: ($$renderer3) => {
          props.children?.($$renderer3);
          $$renderer3.push(`<!---->`);
        },
        $$slots: { default: true }
      }
    ]));
  });
}
function Mic($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { $$slots, $$events, ...props } = $$props;
    const iconNode = [
      ["path", { "d": "M12 19v3" }],
      ["path", { "d": "M19 10v2a7 7 0 0 1-14 0v-2" }],
      [
        "rect",
        { "x": "9", "y": "2", "width": "6", "height": "13", "rx": "3" }
      ]
    ];
    Icon($$renderer2, spread_props([
      { name: "mic" },
      /**
       * @component @name Mic
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTl2MyIgLz4KICA8cGF0aCBkPSJNMTkgMTB2MmE3IDcgMCAwIDEtMTQgMHYtMiIgLz4KICA8cmVjdCB4PSI5IiB5PSIyIiB3aWR0aD0iNiIgaGVpZ2h0PSIxMyIgcng9IjMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/mic
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      props,
      {
        iconNode,
        children: ($$renderer3) => {
          props.children?.($$renderer3);
          $$renderer3.push(`<!---->`);
        },
        $$slots: { default: true }
      }
    ]));
  });
}
function Microscope($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { $$slots, $$events, ...props } = $$props;
    const iconNode = [
      ["path", { "d": "M6 18h8" }],
      ["path", { "d": "M3 22h18" }],
      ["path", { "d": "M14 22a7 7 0 1 0 0-14h-1" }],
      ["path", { "d": "M9 14h2" }],
      ["path", { "d": "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z" }],
      ["path", { "d": "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3" }]
    ];
    Icon($$renderer2, spread_props([
      { name: "microscope" },
      /**
       * @component @name Microscope
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiAxOGg4IiAvPgogIDxwYXRoIGQ9Ik0zIDIyaDE4IiAvPgogIDxwYXRoIGQ9Ik0xNCAyMmE3IDcgMCAxIDAgMC0xNGgtMSIgLz4KICA8cGF0aCBkPSJNOSAxNGgyIiAvPgogIDxwYXRoIGQ9Ik05IDEyYTIgMiAwIDAgMS0yLTJWNmg2djRhMiAyIDAgMCAxLTIgMloiIC8+CiAgPHBhdGggZD0iTTEyIDZWM2ExIDEgMCAwIDAtMS0xSDlhMSAxIDAgMCAwLTEgMXYzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/microscope
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      props,
      {
        iconNode,
        children: ($$renderer3) => {
          props.children?.($$renderer3);
          $$renderer3.push(`<!---->`);
        },
        $$slots: { default: true }
      }
    ]));
  });
}
function Music($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { $$slots, $$events, ...props } = $$props;
    const iconNode = [
      ["path", { "d": "M9 18V5l12-2v13" }],
      ["circle", { "cx": "6", "cy": "18", "r": "3" }],
      ["circle", { "cx": "18", "cy": "16", "r": "3" }]
    ];
    Icon($$renderer2, spread_props([
      { name: "music" },
      /**
       * @component @name Music
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOSAxOFY1bDEyLTJ2MTMiIC8+CiAgPGNpcmNsZSBjeD0iNiIgY3k9IjE4IiByPSIzIiAvPgogIDxjaXJjbGUgY3g9IjE4IiBjeT0iMTYiIHI9IjMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/music
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      props,
      {
        iconNode,
        children: ($$renderer3) => {
          props.children?.($$renderer3);
          $$renderer3.push(`<!---->`);
        },
        $$slots: { default: true }
      }
    ]));
  });
}
function Palette($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { $$slots, $$events, ...props } = $$props;
    const iconNode = [
      [
        "path",
        {
          "d": "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z"
        }
      ],
      [
        "circle",
        { "cx": "13.5", "cy": "6.5", "r": ".5", "fill": "currentColor" }
      ],
      [
        "circle",
        {
          "cx": "17.5",
          "cy": "10.5",
          "r": ".5",
          "fill": "currentColor"
        }
      ],
      [
        "circle",
        { "cx": "6.5", "cy": "12.5", "r": ".5", "fill": "currentColor" }
      ],
      [
        "circle",
        { "cx": "8.5", "cy": "7.5", "r": ".5", "fill": "currentColor" }
      ]
    ];
    Icon($$renderer2, spread_props([
      { name: "palette" },
      /**
       * @component @name Palette
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMjJhMSAxIDAgMCAxIDAtMjAgMTAgOSAwIDAgMSAxMCA5IDUgNSAwIDAgMS01IDVoLTIuMjVhMS43NSAxLjc1IDAgMCAwLTEuNCAyLjhsLjMuNGExLjc1IDEuNzUgMCAwIDEtMS40IDIuOHoiIC8+CiAgPGNpcmNsZSBjeD0iMTMuNSIgY3k9IjYuNSIgcj0iLjUiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KICA8Y2lyY2xlIGN4PSIxNy41IiBjeT0iMTAuNSIgcj0iLjUiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KICA8Y2lyY2xlIGN4PSI2LjUiIGN5PSIxMi41IiByPSIuNSIgZmlsbD0iY3VycmVudENvbG9yIiAvPgogIDxjaXJjbGUgY3g9IjguNSIgY3k9IjcuNSIgcj0iLjUiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/palette
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      props,
      {
        iconNode,
        children: ($$renderer3) => {
          props.children?.($$renderer3);
          $$renderer3.push(`<!---->`);
        },
        $$slots: { default: true }
      }
    ]));
  });
}
const badgeVariants = tv({
  base: "focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded border px-2 py-0.5 text-xs font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:ring-[3px] [&>svg]:pointer-events-none [&>svg]:size-3",
  variants: {
    variant: {
      default: "bg-primary text-primary-foreground [a&]:hover:bg-primary/90 border-transparent",
      secondary: "bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90 border-transparent",
      destructive: "bg-destructive [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/70 border-transparent text-white",
      outline: "text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground"
    }
  },
  defaultVariants: { variant: "default" }
});
function Badge($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let {
      ref = null,
      href,
      class: className,
      variant = "default",
      children,
      $$slots,
      $$events,
      ...restProps
    } = $$props;
    element(
      $$renderer2,
      href ? "a" : "span",
      () => {
        $$renderer2.push(`${attributes({
          "data-slot": "badge",
          href,
          class: clsx(cn(badgeVariants({ variant }), className)),
          ...restProps
        })}`);
      },
      () => {
        children?.($$renderer2);
        $$renderer2.push(`<!---->`);
      }
    );
    bind_props($$props, { ref });
  });
}
function WorkshopDetailModal($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { workshop, isOpen } = $$props;
    const discountPercent = workshop?.discount || 0;
    function handleEnroll() {
      window.open(`https://wa.me/+917814688725?text=Hi! I'm interested in the "${workshop.title}" workshop.`, "_blank");
    }
    function handleShare() {
      if (navigator.share) {
        navigator.share({
          title: workshop.title,
          text: `Check out this workshop: ${workshop.title}`,
          url: window.location.href
        });
      }
    }
    if (isOpen && workshop) {
      $$renderer2.push("<!--[-->");
      $$renderer2.push(`<div class="fixed inset-0 z-50 flex items-center justify-center p-4"><button class="absolute inset-0 bg-black/60 backdrop-blur-sm" aria-label="Close modal"></button> <div class="relative max-h-[90vh] w-full max-w-4xl overflow-hidden rounded-3xl bg-white shadow-2xl"><button class="absolute top-4 right-4 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-white/90 shadow-lg transition-all hover:bg-white">`);
      X($$renderer2, { class: "h-5 w-5" });
      $$renderer2.push(`<!----></button> <div class="max-h-[90vh] overflow-y-auto"><div class="relative h-64 sm:h-80"><img${attr("src", workshop.coverImg || `https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=1200&q=80`)}${attr("alt", workshop.title)} class="h-full w-full object-cover"/> <div class="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div> <div class="absolute top-4 left-4 flex gap-2">`);
      if (workshop.isFeatured) {
        $$renderer2.push("<!--[-->");
        Badge($$renderer2, {
          class: "border-0 bg-orange-500 text-white",
          variant: "secondary",
          children: ($$renderer3) => {
            Star($$renderer3, { class: "mr-1 h-3 w-3" });
            $$renderer3.push(`<!----> Featured`);
          },
          $$slots: { default: true }
        });
      } else {
        $$renderer2.push("<!--[!-->");
      }
      $$renderer2.push(`<!--]--> `);
      if (discountPercent > 0) {
        $$renderer2.push("<!--[-->");
        Badge($$renderer2, {
          class: "border-0 bg-green-500 text-white",
          variant: "secondary",
          children: ($$renderer3) => {
            $$renderer3.push(`<!---->${escape_html(discountPercent)}% OFF`);
          },
          $$slots: { default: true }
        });
      } else {
        $$renderer2.push("<!--[!-->");
      }
      $$renderer2.push(`<!--]--></div> <div class="absolute right-0 bottom-0 left-0 p-6 sm:p-8">`);
      Badge($$renderer2, {
        variant: "secondary",
        class: "mb-3 bg-white/90 text-gray-900 capitalize",
        children: ($$renderer3) => {
          $$renderer3.push(`<!---->${escape_html(workshop.category)}`);
        },
        $$slots: { default: true }
      });
      $$renderer2.push(`<!----> <h2 class="mb-2 text-2xl font-bold text-white sm:text-3xl">${escape_html(workshop.title)}</h2> `);
      if (workshop.subtitle) {
        $$renderer2.push("<!--[-->");
        $$renderer2.push(`<p class="text-white/80">${escape_html(workshop.subtitle)}</p>`);
      } else {
        $$renderer2.push("<!--[!-->");
      }
      $$renderer2.push(`<!--]--></div></div> <div class="p-6 sm:p-8"><div class="grid gap-8 lg:grid-cols-3"><div class="space-y-8 lg:col-span-2">`);
      if (workshop.instructor?.name) {
        $$renderer2.push("<!--[-->");
        $$renderer2.push(`<div class="rounded-xl bg-gray-50 p-6"><h3 class="mb-4 flex items-center gap-2 text-lg font-semibold text-gray-900">`);
        User($$renderer2, { class: "h-5 w-5 text-orange-500" });
        $$renderer2.push(`<!----> About the Instructor</h3> <div class="flex gap-4"><img${attr("src", workshop.instructor.photo || `https://ui-avatars.com/api/?name=${workshop.instructor.name}&background=f97316&color=fff&size=100`)}${attr("alt", workshop.instructor.name)} class="h-20 w-20 flex-shrink-0 rounded-full border-2 border-orange-200 object-cover"/> <div><p class="text-lg font-semibold text-gray-900">${escape_html(workshop.instructor.name)}</p> <p class="mb-2 text-sm text-gray-600">${escape_html(workshop.instructor.role)}</p> `);
        if (workshop.instructor.about) {
          $$renderer2.push("<!--[-->");
          $$renderer2.push(`<p class="text-sm leading-relaxed text-gray-600">${escape_html(workshop.instructor.about)}</p>`);
        } else {
          $$renderer2.push("<!--[!-->");
        }
        $$renderer2.push(`<!--]--></div></div></div>`);
      } else {
        $$renderer2.push("<!--[!-->");
      }
      $$renderer2.push(`<!--]--> `);
      if (workshop.description) {
        $$renderer2.push("<!--[-->");
        $$renderer2.push(`<div><h3 class="mb-3 flex items-center gap-2 text-lg font-semibold text-gray-900">`);
        Book_open($$renderer2, { class: "h-5 w-5 text-orange-500" });
        $$renderer2.push(`<!----> About This Workshop</h3> <p class="leading-relaxed text-gray-600">${escape_html(workshop.description)}</p></div>`);
      } else {
        $$renderer2.push("<!--[!-->");
      }
      $$renderer2.push(`<!--]--> `);
      if (workshop.whatYouLearn && workshop.whatYouLearn.length > 0) {
        $$renderer2.push("<!--[-->");
        $$renderer2.push(`<div><h3 class="mb-3 flex items-center gap-2 text-lg font-semibold text-gray-900">`);
        Target($$renderer2, { class: "h-5 w-5 text-orange-500" });
        $$renderer2.push(`<!----> What You'll Learn</h3> <ul class="space-y-2"><!--[-->`);
        const each_array = ensure_array_like(workshop.whatYouLearn);
        for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
          let item = each_array[$$index];
          $$renderer2.push(`<li class="flex items-start gap-3">`);
          Circle_check_big($$renderer2, { class: "mt-0.5 h-5 w-5 flex-shrink-0 text-green-500" });
          $$renderer2.push(`<!----> <span class="text-gray-600">${escape_html(item)}</span></li>`);
        }
        $$renderer2.push(`<!--]--></ul></div>`);
      } else {
        $$renderer2.push("<!--[!-->");
      }
      $$renderer2.push(`<!--]--> `);
      if (workshop.requirements && workshop.requirements.length > 0) {
        $$renderer2.push("<!--[-->");
        $$renderer2.push(`<div><h3 class="mb-3 flex items-center gap-2 text-lg font-semibold text-gray-900">`);
        List($$renderer2, { class: "h-5 w-5 text-orange-500" });
        $$renderer2.push(`<!----> Requirements</h3> <ul class="space-y-2"><!--[-->`);
        const each_array_1 = ensure_array_like(workshop.requirements);
        for (let $$index_1 = 0, $$length = each_array_1.length; $$index_1 < $$length; $$index_1++) {
          let item = each_array_1[$$index_1];
          $$renderer2.push(`<li class="flex items-start gap-3">`);
          Circle_alert($$renderer2, { class: "mt-0.5 h-5 w-5 flex-shrink-0 text-blue-500" });
          $$renderer2.push(`<!----> <span class="text-gray-600">${escape_html(item)}</span></li>`);
        }
        $$renderer2.push(`<!--]--></ul></div>`);
      } else {
        $$renderer2.push("<!--[!-->");
      }
      $$renderer2.push(`<!--]--></div> <div class="lg:col-span-1"><div class="sticky top-4 rounded-2xl bg-gray-50 p-6"><div class="mb-6 border-b border-gray-200 pb-6 text-center"><div class="mb-1 flex items-baseline justify-center gap-2"><span class="text-4xl font-bold text-gray-900">₹${escape_html(workshop.offerPrice?.toLocaleString())}</span> `);
      if (workshop.offerPrice < workshop.actualPrice) {
        $$renderer2.push("<!--[-->");
        $$renderer2.push(`<span class="text-lg text-gray-400 line-through">₹${escape_html(workshop.actualPrice?.toLocaleString())}</span>`);
      } else {
        $$renderer2.push("<!--[!-->");
      }
      $$renderer2.push(`<!--]--></div> `);
      if (discountPercent > 0) {
        $$renderer2.push("<!--[-->");
        $$renderer2.push(`<span class="font-medium text-green-600">Save ${escape_html(discountPercent)}%!</span>`);
      } else {
        $$renderer2.push("<!--[!-->");
      }
      $$renderer2.push(`<!--]--></div> <div class="mb-6 space-y-4"><div class="flex items-center gap-3 text-gray-600">`);
      Clock($$renderer2, { class: "h-5 w-5 text-orange-500" });
      $$renderer2.push(`<!----> <span>${escape_html(workshop.hours)} Hours (${escape_html(workshop.sessions)} Sessions)</span></div> <div class="flex items-center gap-3 text-gray-600">`);
      Users($$renderer2, { class: "h-5 w-5 text-orange-500" });
      $$renderer2.push(`<!----> <span>${escape_html(workshop.seatsLeft)} seats left of ${escape_html(workshop.totalSeats || 30)}</span></div> `);
      if (workshop.date) {
        $$renderer2.push("<!--[-->");
        $$renderer2.push(`<div class="flex items-center gap-3 text-gray-600">`);
        Calendar($$renderer2, { class: "h-5 w-5 text-orange-500" });
        $$renderer2.push(`<!----> <span>Starts ${escape_html(workshop.date)}</span></div>`);
      } else {
        $$renderer2.push("<!--[!-->");
      }
      $$renderer2.push(`<!--]--> `);
      if (workshop.ageGroup) {
        $$renderer2.push("<!--[-->");
        $$renderer2.push(`<div class="flex items-center gap-3 text-gray-600">`);
        Users($$renderer2, { class: "h-5 w-5 text-orange-500" });
        $$renderer2.push(`<!----> <span>Ages: ${escape_html(workshop.ageGroup)}</span></div>`);
      } else {
        $$renderer2.push("<!--[!-->");
      }
      $$renderer2.push(`<!--]--></div> <div class="mb-6 space-y-3 border-b border-gray-200 pb-6"><p class="font-medium text-gray-900">This workshop includes:</p> `);
      if (workshop.certificate) {
        $$renderer2.push("<!--[-->");
        $$renderer2.push(`<div class="flex items-center gap-2 text-gray-600">`);
        Award($$renderer2, { class: "h-4 w-4 text-green-500" });
        $$renderer2.push(`<!----> <span class="text-sm">Certificate of Completion</span></div>`);
      } else {
        $$renderer2.push("<!--[!-->");
      }
      $$renderer2.push(`<!--]--> `);
      if (workshop.recording) {
        $$renderer2.push("<!--[-->");
        $$renderer2.push(`<div class="flex items-center gap-2 text-gray-600">`);
        Play($$renderer2, { class: "h-4 w-4 text-blue-500" });
        $$renderer2.push(`<!----> <span class="text-sm">Lifetime Recording Access</span></div>`);
      } else {
        $$renderer2.push("<!--[!-->");
      }
      $$renderer2.push(`<!--]--> `);
      if (workshop.whatsappSupport) {
        $$renderer2.push("<!--[-->");
        $$renderer2.push(`<div class="flex items-center gap-2 text-gray-600">`);
        Message_circle($$renderer2, { class: "h-4 w-4 text-purple-500" });
        $$renderer2.push(`<!----> <span class="text-sm">WhatsApp Support</span></div>`);
      } else {
        $$renderer2.push("<!--[!-->");
      }
      $$renderer2.push(`<!--]--></div> `);
      if (workshop.level) {
        $$renderer2.push("<!--[-->");
        $$renderer2.push(`<div class="mb-4">`);
        Badge($$renderer2, {
          variant: "outline",
          class: "text-xs font-medium",
          children: ($$renderer3) => {
            Trending_up($$renderer3, { class: "mr-1 h-3 w-3" });
            $$renderer3.push(`<!----> ${escape_html(workshop.level)} Level`);
          },
          $$slots: { default: true }
        });
        $$renderer2.push(`<!----></div>`);
      } else {
        $$renderer2.push("<!--[!-->");
      }
      $$renderer2.push(`<!--]--> `);
      Button($$renderer2, {
        variant: "default",
        onclick: handleEnroll,
        class: "w-full rounded-xl bg-gradient-to-r from-orange-500 to-orange-600 py-6 text-lg text-white shadow-lg shadow-orange-500/25 hover:from-orange-600 hover:to-orange-700",
        children: ($$renderer3) => {
          $$renderer3.push(`<!---->Enroll Now`);
        },
        $$slots: { default: true }
      });
      $$renderer2.push(`<!----> `);
      Button($$renderer2, {
        variant: "outline",
        class: "mt-3 w-full",
        onclick: handleShare,
        children: ($$renderer3) => {
          Share_2($$renderer3, { class: "mr-2 h-4 w-4" });
          $$renderer3.push(`<!----> Share Workshop`);
        },
        $$slots: { default: true }
      });
      $$renderer2.push(`<!----></div></div></div></div></div></div></div>`);
    } else {
      $$renderer2.push("<!--[!-->");
    }
    $$renderer2.push(`<!--]-->`);
  });
}
function WorkshopCard($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let showModal = false;
    let ws = fallback(
      $$props["ws"],
      () => ({
        coverImg: "/images/ai-cover.jpg",
        isFeatured: true,
        discount: 43,
        isLive: true,
        tag: "Ai",
        level: "Beginner",
        title: "AI & ChatGPT Masterclass for Students",
        subtitle: "Learn how AI works and create your own AI projects",
        instructor: { name: "Dr. Priya Verma", role: "Instructor", photo: "" },
        sessions: 3,
        hours: 6,
        seatsLeft: 7,
        date: "May 25, 2025",
        certificate: true,
        recording: true,
        offerPrice: 1999,
        actualPrice: 3499,
        ageGroup: "12-18 years"
      }),
      true
    );
    $$renderer2.push(`<div class="mx-auto flex w-full flex-col overflow-hidden rounded-2xl border bg-white shadow-card transition hover:shadow-lg"><div class="group relative flex h-[148px] items-center justify-center bg-gray-100"><img${attr("src", ws.coverImg)} alt="Workshop cover" class="h-full w-full object-cover"/> <div class="absolute top-3 left-3 z-10 flex gap-2">`);
    if (ws.isFeatured) {
      $$renderer2.push("<!--[-->");
      Badge($$renderer2, {
        class: "rounded-full bg-orange-100 px-2 py-0.5 text-xs font-semibold text-orange-700",
        variant: "secondary",
        href: "#",
        children: ($$renderer3) => {
          $$renderer3.push(`<!---->Featured`);
        },
        $$slots: { default: true }
      });
    } else {
      $$renderer2.push("<!--[!-->");
    }
    $$renderer2.push(`<!--]--> `);
    if (ws.discount > 0) {
      $$renderer2.push("<!--[-->");
      Badge($$renderer2, {
        class: "rounded-full bg-green-100 px-2 py-0.5 text-xs font-semibold text-green-700",
        variant: "secondary",
        href: "#",
        children: ($$renderer3) => {
          $$renderer3.push(`<!---->${escape_html(ws.discount)}% OFF`);
        },
        $$slots: { default: true }
      });
    } else {
      $$renderer2.push("<!--[!-->");
    }
    $$renderer2.push(`<!--]--></div> `);
    if (ws.isLive) {
      $$renderer2.push("<!--[-->");
      Badge($$renderer2, {
        class: "absolute top-3 right-3 z-10 rounded-full bg-red-500 px-2 py-0.5 text-xs font-semibold text-white",
        variant: "secondary",
        href: "#",
        children: ($$renderer3) => {
          $$renderer3.push(`<!---->LIVE`);
        },
        $$slots: { default: true }
      });
    } else {
      $$renderer2.push("<!--[!-->");
    }
    $$renderer2.push(`<!--]--> <div class="pointer-events-none absolute inset-0 z-10 hidden cursor-pointer items-center justify-center group-hover:flex"><div class="flex cursor-pointer items-center justify-center rounded-full bg-white/90 p-3 shadow-md"><svg width="36" height="36" viewBox="0 0 36 36" fill="none"><circle cx="18" cy="18" r="18" fill="#fb923c" fill-opacity="0.11"></circle><polygon points="15,12 25,18 15,24" fill="#fb923c"></polygon></svg></div></div> <div class="absolute bottom-3 left-3 flex items-center gap-2">`);
    Badge($$renderer2, {
      class: "rounded-full bg-black/80 px-2 py-0.5 text-[11px] font-medium text-white",
      variant: "secondary",
      href: "#",
      children: ($$renderer3) => {
        $$renderer3.push(`<!---->${escape_html(ws.tag)}`);
      },
      $$slots: { default: true }
    });
    $$renderer2.push(`<!----></div> <div class="absolute right-3 bottom-3">`);
    Badge($$renderer2, {
      class: "rounded-full bg-green-100 px-2 py-0.5 text-[11px] font-medium text-green-700",
      variant: "secondary",
      href: "#",
      children: ($$renderer3) => {
        $$renderer3.push(`<!---->${escape_html(ws.level)}`);
      },
      $$slots: { default: true }
    });
    $$renderer2.push(`<!----></div></div> <div class="flex flex-1 flex-col px-5 py-4"><div class="mb-1 text-[1.09rem] leading-snug font-semibold text-orange-700">${escape_html(ws.title)}</div> <div class="mb-3 text-sm text-gray-600">${escape_html(ws.subtitle)}</div> <div class="mb-3 flex items-center gap-3"><div class="flex size-9 items-center justify-center rounded-full bg-orange-100 text-base font-semibold text-orange-700">`);
    if (ws.instructor.photo) {
      $$renderer2.push("<!--[-->");
      $$renderer2.push(`<img${attr("src", ws.instructor.photo)}${attr("alt", ws.instructor.name)} class="h-full w-full rounded-full object-cover"/>`);
    } else {
      $$renderer2.push("<!--[!-->");
      $$renderer2.push(`${escape_html(ws.instructor.name.split(" ").map((w) => w[0]).join(""))}`);
    }
    $$renderer2.push(`<!--]--></div> <div class="leading-[1.1]"><div class="text-[15px] font-semibold text-gray-800">${escape_html(ws.instructor.name)}</div> <div class="text-xs text-gray-500">${escape_html(ws.instructor.role)}</div></div></div> <div class="mb-3 flex flex-wrap items-center gap-x-5 gap-y-2 text-[15px] text-gray-700"><div class="flex items-center gap-1.5 whitespace-nowrap">`);
    Clock($$renderer2, { size: 17, class: "-mt-0.5 text-orange-500" });
    $$renderer2.push(`<!----> ${escape_html(ws.hours)} Hours (${escape_html(ws.sessions)} Sessions)</div> <div class="flex items-center gap-1.5 whitespace-nowrap">`);
    Users($$renderer2, { size: 17, class: "-mt-0.5 text-violet-500" });
    $$renderer2.push(`<!----> ${escape_html(ws.seatsLeft)} seats left</div></div> <div class="mb-3 flex flex-wrap items-center gap-x-5 gap-y-2 text-[15px] text-gray-700"><div class="flex items-center gap-1.5 whitespace-nowrap">`);
    Calendar($$renderer2, { size: 17, class: "-mt-0.5 text-blue-600" });
    $$renderer2.push(`<!----> ${escape_html(ws.date)}</div></div> <div class="mb-3 flex flex-wrap gap-3">`);
    if (ws.certificate) {
      $$renderer2.push("<!--[-->");
      Badge($$renderer2, {
        class: "flex items-center gap-1 bg-green-50 px-2 py-1 text-xs font-medium text-green-700",
        variant: "secondary",
        href: "#",
        children: ($$renderer3) => {
          Award($$renderer3, { size: 15, class: "mr-1 mb-px inline-block" });
          $$renderer3.push(`<!----> Certificate`);
        },
        $$slots: { default: true }
      });
    } else {
      $$renderer2.push("<!--[!-->");
    }
    $$renderer2.push(`<!--]--> `);
    if (ws.recording) {
      $$renderer2.push("<!--[-->");
      Badge($$renderer2, {
        class: "flex items-center gap-1 bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700",
        variant: "secondary",
        href: "#",
        children: ($$renderer3) => {
          $$renderer3.push(`<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20" class="mr-1 mb-px inline-block" fill="currentColor"><circle cx="10" cy="10" r="9" fill="#dbeafe"></circle><circle cx="10" cy="10" r="5" fill="#3b82f6"></circle></svg> Recording`);
        },
        $$slots: { default: true }
      });
    } else {
      $$renderer2.push("<!--[!-->");
    }
    $$renderer2.push(`<!--]--></div> <div class="mt-3 flex items-center justify-between border-t py-2 pt-3"><div><div class="flex items-center gap-2"><span class="text-2xl font-bold text-green-700">₹${escape_html(ws.offerPrice.toLocaleString())}</span> <span class="text-base text-gray-400 line-through">₹${escape_html(ws.actualPrice.toLocaleString())}</span></div> <div class="text-xs text-gray-400">Ages: ${escape_html(ws.ageGroup)}</div></div> `);
    Button($$renderer2, {
      onclick: () => showModal = true,
      size: "sm",
      class: "",
      children: ($$renderer3) => {
        $$renderer3.push(`<!---->Enroll Now`);
      },
      $$slots: { default: true }
    });
    $$renderer2.push(`<!----></div></div> `);
    WorkshopDetailModal($$renderer2, {
      workshop: ws,
      isOpen: showModal
    });
    $$renderer2.push(`<!----></div>`);
    bind_props($$props, { ws });
  });
}
function WorkshopFilter($$renderer, $$props) {
  let categoryButtonLabel;
  let categories2 = fallback($$props["categories"], () => [], true);
  let selectedCategory = fallback($$props["selectedCategory"], null);
  let searchQuery = fallback($$props["searchQuery"], "");
  let selectedSort = fallback($$props["selectedSort"], "Featured");
  let sortOptions = ["Featured", "Newest", "Oldest", "Seats Left"];
  const ALL_CATEGORIES = "All Categories";
  categoryButtonLabel = selectedCategory ? selectedCategory : ALL_CATEGORIES;
  $$renderer.push(`<div class="mb-9 w-full rounded-xl bg-white px-2.5 p-4 md:px-4 md:p-5 border flex flex-col md:flex-row items-stretch gap-2 md:gap-3"><div class="relative flex-1 min-w-[120px] md:min-w-[230px]"><input type="text" class="block w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 pl-8 pr-8 text-[15px] text-gray-700 placeholder:text-gray-400 focus:border-orange-300 focus:ring-orange-100 transition"${attr("value", searchQuery)} placeholder="Search workshops..."/> <span class="pointer-events-none absolute left-2 top-0 flex h-full items-center text-gray-400"><svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" class="lucide lucide-search"><circle cx="7" cy="7" r="5"></circle><line x1="12.5" y1="12.5" x2="10.2" y2="10.2"></line></svg></span> `);
  if (searchQuery) {
    $$renderer.push("<!--[-->");
    $$renderer.push(`<button type="button" class="absolute right-2 top-0 flex h-full items-center text-gray-400 hover:text-gray-600 transition-colors" aria-label="Clear search"><svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" class="lucide lucide-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>`);
  } else {
    $$renderer.push("<!--[!-->");
  }
  $$renderer.push(`<!--]--></div> <div class="relative"><button type="button" class="inline-flex items-center cursor-pointer text-gray-600 border border-gray-200 rounded-lg bg-white px-3 py-2 text-[15px] font-medium hover:bg-gray-100 transition whitespace-nowrap" aria-label="Filter by category"><svg class="mr-1.5 text-gray-400" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><line x1="4" y1="21" x2="4" y2="14"></line><line x1="4" y1="10" x2="4" y2="3"></line><line x1="12" y1="21" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="3"></line><line x1="20" y1="21" x2="20" y2="16"></line><line x1="20" y1="12" x2="20" y2="3"></line><line x1="1" y1="14" x2="7" y2="14"></line><line x1="9" y1="8" x2="15" y2="8"></line><line x1="17" y1="16" x2="23" y2="16"></line></svg> <span class="mr-1">${escape_html(categoryButtonLabel)}</span> <svg class="text-gray-400" width="14" height="14" fill="none" viewBox="0 0 20 20"><path d="M6 8l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button> `);
  {
    $$renderer.push("<!--[!-->");
  }
  $$renderer.push(`<!--]--></div> <div>`);
  $$renderer.select(
    {
      class: "block rounded-lg border border-gray-200 px-3 py-2 text-[15px] bg-white text-gray-700 focus:border-orange-300 focus:ring-orange-100 transition w-full",
      value: selectedSort,
      "aria-label": "Sort"
    },
    ($$renderer2) => {
      $$renderer2.push(`<!--[-->`);
      const each_array_1 = ensure_array_like(sortOptions);
      for (let $$index_1 = 0, $$length = each_array_1.length; $$index_1 < $$length; $$index_1++) {
        let sort = each_array_1[$$index_1];
        $$renderer2.option({ value: sort }, ($$renderer3) => {
          $$renderer3.push(`${escape_html(sort)}`);
        });
      }
      $$renderer2.push(`<!--]-->`);
    }
  );
  $$renderer.push(`</div></div>`);
  bind_props($$props, { categories: categories2, selectedCategory, searchQuery, selectedSort });
}
const categories = [
  {
    title: "Coding",
    icon: Code,
    iconColorClass: "bg-blue-100 text-blue-500",
    className: "border border-gray-100",
    workshops: 1
  },
  {
    title: "AI & Machine Learning",
    icon: { Brain },
    iconColorClass: "bg-fuchsia-100 text-fuchsia-600",
    className: "border border-gray-100",
    workshops: 1
  },
  {
    title: "Music",
    icon: Music,
    iconColorClass: "bg-orange-100 text-orange-500",
    className: "border border-gray-100",
    workshops: 1
  },
  {
    title: "Dance",
    icon: Footprints,
    iconColorClass: "bg-pink-100 text-pink-500",
    className: "border border-gray-100",
    workshops: 1
  },
  {
    title: "Mathematics",
    icon: Calculator,
    iconColorClass: "bg-green-100 text-green-500",
    className: "border border-gray-100",
    workshops: 0
  },
  {
    title: "Science",
    icon: Microscope,
    iconColorClass: "bg-indigo-100 text-indigo-500",
    className: "border border-gray-100",
    workshops: 0
  },
  {
    title: "English",
    icon: Languages,
    iconColorClass: "bg-yellow-100 text-yellow-600",
    className: "border border-gray-100",
    workshops: 0
  },
  {
    title: "Public Speaking",
    icon: Mic,
    iconColorClass: "bg-teal-100 text-teal-500",
    className: "border border-gray-100",
    workshops: 1
  },
  {
    title: "Art & Creativity",
    icon: Palette,
    iconColorClass: "bg-purple-100 text-purple-600",
    className: "border border-gray-100",
    workshops: 0
  },
  {
    title: "SAT Prep",
    icon: File_check,
    iconColorClass: "bg-gray-800 text-gray-100",
    className: "border border-gray-100 bg-gray-50",
    workshops: 1
  }
];
const workshops = [
  {
    coverImg: "https://images.unsplash.com/photo-1526379095098-d400fd0bf935?w=800&q=80",
    isFeatured: true,
    discount: 50,
    isLive: true,
    tag: "Coding",
    level: "beginner",
    title: "Master Python Programming - From Zero to Hero",
    subtitle: "Complete Python course for beginners with hands-on projects",
    instructor: {
      name: "Rahul Sharma",
      role: "Workshop Instructor",
      photo: "",
      about: "Senior Software Engineer with 8+ years of experience teaching kids and teenagers"
    },
    sessions: 4,
    hours: 8,
    seatsLeft: 8,
    totalSeats: 30,
    date: "May 20, 2025",
    certificate: true,
    recording: true,
    whatsappSupport: true,
    offerPrice: 1499,
    actualPrice: 2999,
    ageGroup: "10-18 years",
    category: "Coding",
    description: "Learn Python programming from scratch! This comprehensive workshop covers everything from basic syntax to advanced concepts like OOP, file handling, and web scraping. Perfect for students aged 10-18 who want to start their coding journey.",
    whatYouLearn: [
      "Python basics and syntax",
      "Variables, loops, and functions",
      "Object-oriented programming",
      "Build real projects",
      "Web scraping basics"
    ],
    requirements: ["Laptop or computer with internet", "No prior coding experience needed"]
  },
  {
    coverImg: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80",
    isFeatured: true,
    discount: 43,
    isLive: true,
    tag: "AI",
    level: "beginner",
    title: "AI & ChatGPT Masterclass for Students",
    subtitle: "Learn how AI works and create your own AI projects",
    instructor: {
      name: "Dr. Priya Verma",
      role: "Workshop Instructor",
      photo: "",
      about: "AI Researcher and Educator with PhD from IIT Delhi"
    },
    sessions: 3,
    hours: 6,
    seatsLeft: 7,
    totalSeats: 25,
    date: "May 25, 2025",
    certificate: true,
    recording: true,
    whatsappSupport: true,
    offerPrice: 1999,
    actualPrice: 3499,
    ageGroup: "12-18 years",
    category: "AI & Machine Learning",
    description: "Discover the fascinating world of Artificial Intelligence! Learn how ChatGPT and other AI tools work, and create your own AI-powered projects. This workshop makes complex AI concepts simple and fun.",
    whatYouLearn: [
      "How AI and Machine Learning work",
      "Using ChatGPT effectively",
      "Create AI art with Midjourney",
      "Build simple AI projects",
      "Ethics in AI"
    ],
    requirements: ["Basic computer skills", "Access to internet"]
  },
  {
    coverImg: "https://images.unsplash.com/photo-1508700929628-666bc8bd84ea?w=800&q=80",
    isFeatured: true,
    discount: 47,
    isLive: true,
    tag: "Dance",
    level: "all_levels",
    title: "Bollywood Dance Workshop",
    subtitle: "Learn trending Bollywood choreography",
    instructor: {
      name: "Neha Kapoor",
      role: "Dance Instructor",
      photo: "",
      about: "Professional choreographer featured in music videos and stage shows"
    },
    sessions: 3,
    hours: 3,
    seatsLeft: 6,
    totalSeats: 20,
    date: "May 24, 2025",
    certificate: true,
    recording: true,
    whatsappSupport: true,
    offerPrice: 799,
    actualPrice: 1499,
    ageGroup: "6-15 years",
    category: "Dance",
    description: "Get ready to groove! Learn the latest Bollywood dance moves and complete choreography to popular songs. Fun, energetic sessions that combine fitness with creativity.",
    whatYouLearn: [
      "Basic dance moves",
      "Complete Bollywood choreography",
      "Expression and performance",
      "Stage presence"
    ],
    requirements: ["Comfortable clothing", "Space to move"]
  },
  {
    coverImg: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800&q=80",
    isFeatured: true,
    discount: 40,
    isLive: true,
    tag: "SAT",
    level: "intermediate",
    title: "SAT Math Intensive Prep",
    subtitle: "Score 700+ on SAT Math section",
    instructor: {
      name: "Lekha V",
      role: "Math Instructor",
      photo: "",
      about: "Mathematics expert with 10+ years online teaching experience"
    },
    sessions: 6,
    hours: 12,
    seatsLeft: 8,
    totalSeats: 15,
    date: "June 1, 2025",
    certificate: true,
    recording: true,
    whatsappSupport: true,
    offerPrice: 2999,
    actualPrice: 4999,
    ageGroup: "15-18 years",
    category: "SAT Prep",
    description: "Comprehensive SAT Math preparation with proven strategies and extensive practice. Learn shortcuts, time management techniques, and tackle even the trickiest problems with confidence.",
    whatYouLearn: [
      "All SAT Math topics",
      "Time-saving strategies",
      "Practice with real questions",
      "Score improvement techniques"
    ],
    requirements: ["Basic algebra knowledge", "Calculator"]
  },
  {
    coverImg: "https://images.unsplash.com/photo-1507838153414-b4b713384a76?w=800&q=80",
    isFeatured: false,
    discount: 50,
    isLive: true,
    tag: "Music",
    level: "beginner",
    title: "Classical Vocal Music - Beginners",
    subtitle: "Learn Indian classical music fundamentals",
    instructor: {
      name: "Pushpank Anmol",
      role: "Music Instructor",
      photo: "",
      about: "3 years teaching with World O Tutors, trained in Hindustani Classical"
    },
    sessions: 4,
    hours: 4,
    seatsLeft: 7,
    totalSeats: 15,
    date: "May 22, 2025",
    certificate: true,
    recording: false,
    whatsappSupport: true,
    offerPrice: 999,
    actualPrice: 1999,
    ageGroup: "8-16 years",
    category: "Music",
    description: "Start your journey into the beautiful world of Indian Classical Music. Learn ragas, talas, and develop your voice under expert guidance. Perfect for beginners with no prior music training.",
    whatYouLearn: [
      "Voice training exercises",
      "Basic ragas",
      "Rhythm and taal",
      "Performance techniques"
    ],
    requirements: ["No prior experience needed", "Quiet space for practice"]
  },
  {
    coverImg: "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?w=800&q=80",
    isFeatured: false,
    discount: 48,
    isLive: true,
    tag: "Public Speaking",
    level: "beginner",
    title: "Public Speaking & Communication Skills",
    subtitle: "Build confidence and ace your presentations",
    instructor: {
      name: "Shikha Mutneja",
      role: "Communication Coach",
      photo: "",
      about: "Communication Coach with 5+ years of experience training students"
    },
    sessions: 5,
    hours: 5,
    seatsLeft: 8,
    totalSeats: 20,
    date: "May 26, 2025",
    certificate: true,
    recording: false,
    whatsappSupport: true,
    offerPrice: 1299,
    actualPrice: 2499,
    ageGroup: "10-16 years",
    category: "Public Speaking",
    description: "Overcome stage fear and become a confident speaker! This interactive workshop focuses on public speaking, body language, and communication skills essential for academic and personal success.",
    whatYouLearn: [
      "Overcome stage fear",
      "Effective body language",
      "Storytelling techniques",
      "Debate and discussion skills",
      "Presentation mastery"
    ],
    requirements: ["Willingness to participate actively"]
  }
];
const testimonials = [
  {
    name: "Ashvath Kolla",
    role: "Parent",
    image: "https://ui-avatars.com/api/?name=Ashvath+Kolla&background=f97316&color=fff&size=200",
    content: "Sonali Ma'am is a great motivator. She encourages our son to explore and learn new things. We're truly grateful for the wonderful teaching.",
    rating: 5
  },
  {
    name: "Janki",
    role: "Parent",
    image: "https://ui-avatars.com/api/?name=Janki&background=3b82f6&color=fff&size=200",
    content: "Ms. Shikha Mutneja teaches so well. My kids enjoy every class and have learned so much—even tricky topics like Rubik's cubes!",
    rating: 5
  },
  {
    name: "Rajat Malhotra",
    role: "Parent, Australia",
    image: "https://ui-avatars.com/api/?name=Rajat+Malhotra&background=10b981&color=fff&size=200",
    content: "This is by far the best online learning platform. My child has improved public speaking and grown in confidence!",
    rating: 5
  },
  {
    name: "Amber Mann",
    role: "Parent, USA",
    image: "https://ui-avatars.com/api/?name=Amber+Mann&background=8b5cf6&color=fff&size=200",
    content: "Shikha Ma'am has been amazing! This tutoring has truly helped my child understand math better and improve her grades.",
    rating: 5
  },
  {
    name: "Trisha Reddy",
    role: "Parent, UK",
    image: "https://ui-avatars.com/api/?name=Trisha+Reddy&background=ec4899&color=fff&size=200",
    content: "Nidhi Bhardwaj Ma'am is a wonderful teacher. She's flexible, caring, and truly connects with my child. Great value and teaching quality!",
    rating: 5
  }
];
const faqs = [
  {
    question: "How do I enroll in a workshop?",
    answer: `Enrolling is simple! Browse our available workshops, click on "Enroll Now" for your preferred workshop, and complete payment. You'll receive confirmation and joining details via email and WhatsApp.`
  },
  {
    question: "Are workshops live or pre-recorded?",
    answer: "All our workshops are LIVE and interactive. You can ask questions, participate in discussions, and get real-time feedback from our expert tutors. Some workshops also include access to recordings for later review."
  },
  {
    question: "What if I miss a session?",
    answer: "Don't worry! If you miss a live session, you can access to recording (if available for your workshop). You can also contact your tutor for a catch-up session or get detailed notes of what was covered."
  },
  {
    question: "Will I receive a certificate?",
    answer: "Yes! Upon successful completion of workshop, you'll receive a digital certificate from World'O'Tutors that you can add to your portfolio or share on social media."
  },
  {
    question: "What age groups are the workshops designed for?",
    answer: "We have workshops for various age groups, typically ranging from 6-18 years. Each workshop listing clearly mentions the recommended age group. Some workshops are also available for adults."
  },
  {
    question: "What technical requirements do I need?",
    answer: "You'll need a stable internet connection, a device (laptop/tablet/phone) with a camera and microphone, and Zoom or our virtual classroom app. Specific software requirements (if any) will be mentioned in the workshop details."
  },
  {
    question: "Can I get a refund if I'm not satisfied?",
    answer: "We offer a satisfaction guarantee! If you're not happy after the first session, you can request a full refund. Please review our refund policy on the website for complete details."
  },
  {
    question: "How do I contact support?",
    answer: "You can reach us 24/7 via WhatsApp at +91 78146 88725, or email us at support@worldotutor.com. We typically respond within 2 hours during business hours."
  }
];
const benefits = [
  {
    title: "Personal Attention",
    desc: "Small batch sizes ensure every student gets individual focus and guidance.",
    icon: User_check,
    iconClasses: "bg-blue-50 text-blue-600",
    border: ""
  },
  {
    title: "Free Certificate",
    desc: "Receive a recognized certificate upon successful completion of the workshop.",
    icon: Award,
    iconClasses: "bg-orange-50 text-orange-500",
    border: ""
  },
  {
    title: "After Class Notes",
    desc: "Get comprehensive notes and resources to revise and practice at your own pace.",
    icon: File_text,
    iconClasses: "bg-green-50 text-green-600",
    border: "border-2 border-yellow-100"
  },
  {
    title: "Live Interactive Sessions",
    desc: "Real-time learning with Q&A sessions and hands-on practice.",
    icon: Video,
    iconClasses: "bg-purple-50 text-purple-500",
    border: ""
  },
  {
    title: "In-depth Knowledge",
    desc: "Expert tutors with top qualifications provide deep insights and practical skills.",
    icon: Book_open,
    iconClasses: "bg-indigo-50 text-indigo-500",
    border: ""
  },
  {
    title: "24/7 Support",
    desc: "Dedicated support team available round the clock via Whatsapp.",
    icon: Circle_question_mark,
    iconClasses: "bg-cyan-50 text-cyan-600",
    border: ""
  }
];
function Workshops($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let filteredWorkshops;
    let selectedCategory = fallback($$props["selectedCategory"], null);
    let searchQuery = "";
    let selectedSort = "Featured";
    filteredWorkshops = workshops.filter((workshop) => {
      const categoryMatch = !selectedCategory || workshop.category === selectedCategory;
      if (!searchQuery) return categoryMatch;
      const searchLower = searchQuery.toLowerCase();
      const titleMatch = workshop.title.toLowerCase().includes(searchLower);
      const subtitleMatch = workshop.subtitle && workshop.subtitle.toLowerCase().includes(searchLower);
      const instructorMatch = workshop.instructor.name && workshop.instructor.name.toLowerCase().includes(searchLower);
      const categorySearchMatch = workshop.category.toLowerCase().includes(searchLower);
      const tagMatch = workshop.tag && workshop.tag.toLowerCase().includes(searchLower);
      const searchMatch = titleMatch || subtitleMatch || instructorMatch || categorySearchMatch || tagMatch;
      return categoryMatch && searchMatch;
    }).sort((a, b) => {
      switch (selectedSort) {
        case "Featured":
          return b.isFeatured - a.isFeatured;
        case "Newest":
          return new Date(b.date) - new Date(a.date);
        case "Oldest":
          return new Date(a.date) - new Date(b.date);
        case "Seats Left":
          return a.seatsLeft - b.seatsLeft;
        default:
          return 0;
      }
    });
    let $$settled = true;
    let $$inner_renderer;
    function $$render_inner($$renderer3) {
      $$renderer3.push(`<section class="pb-12 bg-gray-50"><div class="container"><div class="flex flex-col justify-center items-center py-12"><h2 class="heading-2">Our Workshops</h2> <p class="pt-2">1 workshop available</p></div> `);
      WorkshopFilter($$renderer3, {
        categories,
        get selectedCategory() {
          return selectedCategory;
        },
        set selectedCategory($$value) {
          selectedCategory = $$value;
          $$settled = false;
        },
        get searchQuery() {
          return searchQuery;
        },
        set searchQuery($$value) {
          searchQuery = $$value;
          $$settled = false;
        },
        get selectedSort() {
          return selectedSort;
        },
        set selectedSort($$value) {
          selectedSort = $$value;
          $$settled = false;
        }
      });
      $$renderer3.push(`<!----> `);
      if (searchQuery || selectedCategory || selectedSort !== "Featured") {
        $$renderer3.push("<!--[-->");
        $$renderer3.push(`<div class="mb-4 flex items-center justify-between"><p class="text-sm text-gray-600">${escape_html(filteredWorkshops.length)} workshop${escape_html(filteredWorkshops.length !== 1 ? "s" : "")} found</p> <button class="flex items-center gap-1 text-sm text-gray-600 hover:text-orange-600 transition-colors">`);
        X($$renderer3, { class: "h-4 w-4" });
        $$renderer3.push(`<!----> Clear all filters</button></div>`);
      } else {
        $$renderer3.push("<!--[!-->");
      }
      $$renderer3.push(`<!--]--> <div class="grid grid-cols-1 gap-6 md:grid-cols-3"><!--[-->`);
      const each_array = ensure_array_like(filteredWorkshops);
      for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
        let ws = each_array[$$index];
        WorkshopCard($$renderer3, { ws });
      }
      $$renderer3.push(`<!--]--></div> `);
      if (filteredWorkshops.length === 0) {
        $$renderer3.push("<!--[-->");
        $$renderer3.push(`<div class="col-span-full py-12 text-center"><p class="text-gray-500">No workshops found matching your criteria.</p> <button class="mt-4 text-orange-600 underline hover:text-orange-700">Clear all filters</button></div>`);
      } else {
        $$renderer3.push("<!--[!-->");
      }
      $$renderer3.push(`<!--]--></div></section>`);
    }
    do {
      $$settled = true;
      $$inner_renderer = $$renderer2.copy();
      $$render_inner($$inner_renderer);
    } while (!$$settled);
    $$renderer2.subsume($$inner_renderer);
    bind_props($$props, { selectedCategory });
  });
}
export {
  Award as A,
  Badge as B,
  File_text as F,
  Icon$1 as I,
  Star as S,
  Users as U,
  Workshops as W,
  Icon as a,
  User_check as b,
  categories as c,
  benefits as d,
  faqs as f,
  testimonials as t
};
